module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.65060723.woff";